import gql from 'graphql-tag';

const APPROVE_OTA = gql`
  mutation Mutation($firmwareVersion: String!, $OTP: String!) {
    approveOTA(firmwareVersion: $firmwareVersion, OTP: $OTP) {
      code
    }
  }
`;

export default APPROVE_OTA;
